import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../services/authService';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleCallback = () => {
      const token = searchParams.get('token');
      const userStr = searchParams.get('user');
      const error = searchParams.get('error');

      if (error) {
        console.error('OAuth error:', error);
        navigate('/signin?error=' + error);
        return;
      }

      if (token && userStr) {
        try {
          const user = JSON.parse(userStr);
          authService.saveAuth(token, user);
          const role = user?.role;
          if (role === 'student') navigate('/studio/student');
          else if (role === 'teacher') navigate('/studio/teacher');
          else navigate('/dashboard');
        } catch (err) {
          console.error('Failed to parse user data:', err);
          navigate('/signin?error=invalid_data');
        }
      } else {
        navigate('/signin?error=missing_data');
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="auth-callback-page">
      <div className="auth-callback-container">
        <div className="spinner"></div>
        <p>Completing sign in...</p>
      </div>
    </div>
  );
}
